<div class="modal-header">
  <h5 class="modal-title">{{title}}</h5>
  <button
    type="button"
    class="close"
    (click)="onClose()"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
         class="bi bi-x-lg" viewBox="0 0 16 16">
      <path
        d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
    </svg>
  </button>
</div>
<div class="modal-body">
  <p [innerHTML]="text | safeHtml: 'html'"></p>
  <a *ngIf="link" class="action hover_action mb-4" [href]="link">
    Get More Sessions
    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 13.1328L7 7.13281L1 1.13281" stroke="#fff" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>
  </a>

  <a class="action action-light hover_action " [href]="''">
    Home page
  </a>
</div>
